// @ts-check
import React from "react";
import ReactDOM from "react-dom";
// import { ThemeProvider } from "@material-ui/styles";
// import { CssBaseline } from "@material-ui/core";

//import Themes from "./themes";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
//import { UserProvider } from "./context/UserContext";
import { store } from './_helpers';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

// import './dotenv';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
// import "./assets/styles/tailwind.css";

ReactDOM.render(
  <LayoutProvider>
    <ToastContainer />
    <Provider store={store}>
      <App />
    </Provider>

  </LayoutProvider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
